import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getDailyPayments } from "../../../services";
import { Button } from "primereact/button";
import { Badge } from "primereact/badge";
import PaymentInfo from "../../Dialog/payment/PaymentInfo";
import IPayment from "@/models/Entities/payments/IPayment";
import moment from "moment";

const DailyPayments = () => {
  const [dailyPayments, setDailyPayments] = useState([]);
  const [paymentInfoShow, setPaymentInfoShow] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState<IPayment>();

  interface DailyPayment {
    id: number;
    merchantOid: string;
    status: string;
    paymentDate: Date;
  }

  useEffect(() => {
    fetchDailyPayments();
  }, []);

  const fetchDailyPayments = async () => {
    try {
      const response = await getDailyPayments();
      //setDailyPayments(response);
    } catch (error) {
      console.error("Failed to fetch daily payments:", error);
    }
  };

  const renderStatusColumn = (rowData: DailyPayment) => {
    return <Badge value={rowData.status} severity="danger" />;
  };

  const handleDetailsClick = (rowData: any) => {
    setPaymentInfoShow(true);
    setSelectedPayment(rowData);
    /* paymentExtendedInfo(16).then((res) => {
        console.log("payments:", res)
        
      })
      .catch((err) => console.log(err)); */
  };

  return (
    <div>
      <h4>Daily Payments</h4>
      <DataTable
        value={dailyPayments}
        scrollable
        scrollHeight="400px"
        tableStyle={{ minWidth: "100%" }}
      >
        <Column field="id" header="ID" style={{ maxWidth: "3rem" }} />
        <Column
          field="merchantOid"
          header="Merchant OID"
          style={{ maxWidth: "14rem" }}
        />
        <Column
          header="Date"
          body={(rowData) =>
            rowData.paymentDate && (
              <>{moment(rowData.paymentDate).format("DD/MM/YYYY, h:mm a")}</>
            )
          }
        />
        <Column header="Status" body={renderStatusColumn} />
        <Column
          style={{ textAlign: "right" }}
          body={(rowData) => (
            <Button
              label="Details"
              className="p-button-secondary"
              onClick={() => handleDetailsClick(rowData)}
            />
          )}
        ></Column>
      </DataTable>
      {paymentInfoShow && (
        <PaymentInfo
          visible={paymentInfoShow}
          onHide={() => setPaymentInfoShow(false)}
          data={selectedPayment}
        />
      )}
    </div>
  );
};

export default DailyPayments;
